import { render, staticRenderFns } from "./EditRewardDialog.vue?vue&type=template&id=2bb0dd75&scoped=true"
import script from "./EditRewardDialog.vue?vue&type=script&lang=ts"
export * from "./EditRewardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb0dd75",
  null
  
)

export default component.exports